<template>
  <div class="heatmap">
    <table class="mt-0 text-center table heatmap table-striped table-styled" v-if="filledTeams > 0">
      <thead>
      <tr>
        <th class="p-2">
          <select style="font-size:80% !important;"
                  v-model="field"
                  name=""
                  id=""
                  class="w-100 h-100 m-auto styled-input form-control p-0 m-0">
            <option value="average">{{ $t('message.average') }}</option>
            <option value="median">{{ $t('message.median') }}</option>
            <option value="standarddeviation">{{ $t('message.stddev') }}</option>
            <option value="lowest">{{ $t('message.lowest') }}</option>
            <option value="highest">{{ $t('message.highest') }}</option>
          </select>
        </th>
        <th class="p-2">{{ $t('message.vip') }}</th>
        <th class="p-2" v-for="(vitamin,i) in vitamins">{{ localizedField(vitamin, 'Title') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(team,i) in teams"
          v-bind:key="team.id"
          v-if="team.data && team.data.children.length">
        <!--        <span class="d-block position-relative">-->
        <!--          <pre class="text-white">-->
        <!--          {{team.data}}-->
        <!--        </pre>-->
        <!--        </span>-->
        <td class="text-left p-2">
          <a href="#"
             @click.prevent="openTeamPopup(team)"
             class="score-c-4 heatmap-team-title">
            {{ team.Title }}
          </a>
          <div class="small p-0 m-0 mt-2">
            <div class="counts mb-2 d-flex">
              <div class="membercount w-50">
                <span class="text-muted"><i class="fas fa-user-friends"></i></span>
                {{ team.users.length }}
              </div>
              <div class="admincount w-50">
                <span class="text-muted"><i class="far fa-clipboard"></i></span>
                {{ team.managedBy.length }}
              </div>
            </div>
            <div class="" v-for="manager in team.managedBy">
              {{ manager.fullname }}
            </div>
          </div>
        </td>
        <!--        {{team}}-->
        <td :class="'score-bgct-'+fieldClass(fieldData(team))"
            class="border-right p-4">
          {{ truncate(fieldData(team), 2) }}
        </td>
        <template v-if="team.data.children"
                  v-for="(vitamin,i) in vitamins">
          <template v-if="vitamin.Title === 'Hinderpalen' || vitamin.Title === 'Ongezondheid'">
            <td class="p-4 v-reversed"
                :class="'score-bgct-'+
              fieldClass(getVitaminScore(team,vitamin.id),true)"
            >
              {{ truncate(getVitaminScore(team, vitamin.id), 2) }}
            </td>
          </template>
          <template v-else>
            <td class="p-4"
                :class="'score-bgct-'+
              fieldClass(getVitaminScore(team,vitamin.id))"
            >
              {{ truncate(getVitaminScore(team, vitamin.id), 2) }}
            </td>
          </template>

        </template>
      </tr>
      </tbody>
    </table>
    <p class="mb-0" v-if="filledTeams <= 0">
      {{ $t('message.no_results_yet') }}.
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      field: 'average',
    }
  },
  computed: {
    filledTeams() {
      let count = 0;
      this.teams.forEach(team => {
        if (team.data && team.data.children) {
          count++
        }
      });
      return count;
    }
  },
  methods: {
    fieldClass(int,reverse = false) {
      let r = this.truncate(int, 0);
      if (this.field === 'standarddeviation' || reverse) {
        r = 7 - r
        if(reverse){
          r++
        }
      }
      return r
    },
    fieldData(d) {
      // console.log('t', d);
      let field = this.field;
      if (d.data) {
        if (field === 'average') {
          field = 'vipscore'
        }
        //  console.log('returning', field, d.data[field])
        let result = d.data[field]
        // if(!result){
        //   result = 0.0001
        // }
        return result
      }
      let result = d[field];
      // if(!result){
      //   result = 0.0001
      // }

      return result
    },
    getVitaminScore(team, vitamin_id) {
      let score = '--';
      let vitamin_scores = team.data.children;
      vitamin_scores.forEach(vitaminscore => {
        if (vitaminscore.id === vitamin_id) {
          score = this.fieldData(vitaminscore)
          // score = vitaminscore.average
        }
      });
      return score
    },
    openTeamPopup(team) {
      this.$emit('openTeamPopup', team)
    }
  },
  props: {
    teams: {
      type: Array,
      default() {
        return []
      }
    },
    vitamins: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Review/Heatmap.vue